<ul class="nav nav-secondary mixed-loyalty-nav gap-2">
  <ng-container *ngFor="let item of navItems">
    <a
      class="nav-item d-flex justify-content-center align-items-center py-1"
      [routerLink]="[item.url]"
      [routerLinkActive]="'active'"
      [routerLinkActiveOptions]="{ exact: true }"
    >
      <label class="m-0">{{ item.name | translate }}</label>
    </a>
  </ng-container>
</ul>
